import React, { useState, useEffect, useRef } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { Link, redirect, useLocation, useNavigate } from "react-router-dom";
import {
    FiSearch,
    FiShoppingCart,
    FiHeart,
    FiUser,
    FiHelpCircle,
    FiLogOut,
    FiCreditCard,
} from "react-icons/fi";
import "react-dropdown/style.css";
import useAuthModal from "../store/authWarningModal";
import useUserData from "../store/userStore";
import axiosInstance from "../utils/axiosInstance";
import { toast } from "sonner";
import { handleDeleteAuthCookie } from "../utils/token";
import useCartStore from "../store/cartStore";
import { handleGetLanguage } from "../utils/languageStorage";
import CategoriesMenu from "./CategoriesMenu";
import Switcher from "./switcher";
import NavBarMenuLong from "./NavBarMenuLong";
import GlobeIcon from "../assets/icons/globe.png";
import SunIcon from "../assets/icons/sun.png";
import CartIcon from "../assets/icons/shopping-bag.png";
import UserIcon from "../assets/icons/minus.png";

export default function Navbar({ navClass, navlight, categoriesQuery }) {
    let [scrolling, setScrolling] = useState(false);
    let [isToggle, setToggle] = useState(false);
    let [manu, setManu] = useState("");

    let [isOpen, setIsOpen] = useState(false);
    // let [isFilterOpen, setIsFilterOpen] = useState(false);
    // let [isGenderVisible, setIsGenderVisible] = useState(false);
    let [userManu, setUserManu] = useState(false);
    let dropdownRef = useRef(null);
    let cartRef = useRef(null);
    let userRef = useRef(null);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // const searchQuery = queryParams.get("search");
    // const colorQuery = queryParams.get("colors");
    // const brandQuery = queryParams.get("brands");
    // const sizeQuery = queryParams.get("sizes");
    // const categorieQuery = queryParams.get("categories");
    const typeQuery = queryParams.get("type");

    // const updateQuery = (key, value, targetPath) => {
    //     const searchParams = new URLSearchParams(location.search);

    //     searchParams.set(key, value);

    //     let pathname = targetPath || location.pathname;

    //     if (pathname === "/") {
    //         pathname = "/shop";
    //     }

    //     if (pathname.endsWith("/")) {
    //         pathname = pathname.slice(0, -1);
    //     }

    //     return `${pathname}?${searchParams.toString()}`;
    // };

    // const navigate = useNavigate();
    // const genderQuery = queryParams.get("gender");
    // const removeQuery = (key) => {
    //     const searchParams = new URLSearchParams(location.search);
    //     searchParams.delete(key);
    //     return `${location.pathname}?${searchParams.toString()}`;
    // };

    const language = handleGetLanguage();

    const logOutHandler = async () => {
        await axiosInstance.post("/logout").then((res) => {
            handleDeleteAuthCookie();
            removeUserData();
            toast.success(language === "ka" ? "იუზერი წარმატებით გამოვიდა" : "User logged out");
        });
        // TODO catch block is needed?
    };

    useEffect(() => {
        const handleScroll = () => {
            const isScrolling = window.scrollY > 50;
            setScrolling(isScrolling);
        };
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        const userOutsideClick = (e) => {
            if (userRef.current && !userRef.current.contains(e.target)) {
                setUserManu(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("click", handleOutsideClick);
        window.addEventListener("click", userOutsideClick);

        let current = window.location.pathname;
        setManu(current);
        window.scrollTo(0, 0);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("click", handleOutsideClick);
            window.removeEventListener("click", userOutsideClick);
        };
    }, []);

    const toggleMenu = () => {
        setToggle(!isToggle);
    };

    const { show } = useAuthModal((state) => state);
    const { user, removeUserData } = useUserData((state) => state);
    const { cart } = useCartStore((state) => state);

    const router = useNavigate();

    const translations = {
        en: {
            categories: "Categories",
            shop: "Shop",
            signIn: "Sign in",
            signUp: "Sign up",
            welcome: "Welcome",
            account: "Account",
            contact: "Contact",
            logout: "Logout",
            searchPlaceholder: "Search...",
            Bags: "Bags",
            Wallets: "Wallets",
            Glasses: "Glasses",
            Watches: "Watches",
            "Winter Hats": "Winter Hats",
            "Summer Hats": "Summer Hats",
            Jewellery: "Jewellery",
            "Womans bags": "Womans bags",
            "Sport bags": "Sport bags",
            "School bags": "School bags",
            "Laptop bags": "Laptop bags",
            "Travel bags": "Travel bags",
            "Womans wallet": "Womans wallet",
            "Mans wallet": "Mans wallet",
            "Womans glasses": "Womans glasses",
            "Mans glasses": "Mans glasses",
            "Womans watches": "Womans watches",
            "Mans watches": "Mans watches",
            "Womans hats": "Womans hats",
            "Mans hats": "Mans hats",
            Earring: "Earring",
            Bracelet: "Bracelet",
            Ring: "Ring",
            Necklace: "Necklace",
            Pendant: "Pendant",
            Cross: "Cross",
        },
        ka: {
            categories: "კატეგორიები",
            shop: "მაღაზია",
            signIn: "შესვლა",
            signUp: "რეგისტრაცია",
            welcome: "მოგესალმებით",
            account: "ანგარიში",
            contact: "კონტაქტი",
            logout: "გასვლა",
            searchPlaceholder: "ძიება...",
            Bags: "ჩანთები",
            Wallets: "საფულეები",
            Glasses: "სათვალეები",
            Watches: "საათები",
            "Winter Hats": "ზამთრის ქუდები",
            "Summer Hats": "ზაფხულის ქუდები",
            Jewellery: "სამკაულები",
            "Womans bags": "ქალბატონების ჩანთები",
            "Sport bags": "სპორტული ჩანთები",
            "School bags": "სასკოლო ჩანთები",
            "Laptop bags": "ლეპტოპის ჩანთები",
            "Travel bags": "სამგზავრო ჩანთები",
            "Womans wallet": "ქალბატონების საფულე",
            "Mans wallet": "მამაკაცების საფულე",
            "Womans glasses": "ქალბატონების სათვალეები",
            "Mans glasses": "მამაკაცების სათვალეები",
            "Womans watches": "ქალბატონების საათები",
            "Mans watches": "მამაკაცების საათები",
            "Womans hats": "ქალბატონების ქუდები",
            "Mans hats": "მამაკაცების ქუდები",
            Earring: "საყურეები",
            Bracelet: "ბრასლეტები",
            Ring: "ბეჭდები",
            Necklace: "ყელსაბამები",
            Pendant: "მონსტრები",
            Cross: "ჯვრები",
        },
    };

    const t = translations[language] || translations.en;

    // New function to handle modal opening and burger menu closing
    const handleShowModal = (modalType) => {
        show(modalType);
        setToggle(false);
    };

    return (
        <nav
            id="topnav"
            className={`flex items-center flex-col ${navClass} ${scrolling ? "nav-sticky" : ""}`}
        >
            <div className="w-full xl:container md:px-2 px-0.5 flex items-center justify-between relative">
                {/* Left: Logo */}
                <Link
                    className="logo relative block text-center hover:scale-110 duration-150 ml-8"
                    to="/"
                >
                    {/* <h1 className="md:text-xl text-[18px] absolute left-1/2 transform -translate-x-1/2 -top-5 text-black dark:text-white whitespace-nowrap z-10">
                        Premium outlet
                    </h1>
                    <h1 className="md:text-lg text-[15px] text-black dark:text-white relative z-10">
                        Onlybrands
                    </h1>
                    <h5 className="md:text-sm text-[12px] absolute left-1/2 transform -translate-x-1/2 top-5 whitespace-nowrap">
                        Only Original
                    </h5> */}
                   <img
                        src="/images/Only_brands_1.svg"
                        className="
                            h-14 sm:h-16 md:h-20 lg:h-24
                            w-auto
                            bg-contain bg-center 
                            dark:hidden
                        "
                        alt="logo"
                        />


                    <img
  src="/images/Only_brands_1.svg"
  className="w-48 h-20 bg-contain bg-center hidden dark:block sm:scale-150 filter invert"
  alt="logo"
/>

                </Link>

                <div className="flex lg:hidden">
                    <div className="flex items-center justify-end gap-2 pr-3 pt-1.5">
                        <Switcher />

                        {/* User */}
                        {!user?.name ? (
                            <button
                                onClick={() => handleShowModal()}
                                className="w-9 h-9 rounded-full bg-[#0A1329] flex items-center justify-center"
                            >
                                <img src={UserIcon} alt="User" className="w-5 h-5" />
                            </button>
                        ) : (
                            <Link
                                to="/user-setting"
                                className="w-9 h-9 rounded-full bg-[#0A1329] text-white flex items-center justify-center font-bold"
                            >
                                {user?.name.slice(0, 2).toUpperCase()}
                            </Link>
                        )}

                        {/* Cart */}
                        <button
                            className="w-9 h-9 rounded-full bg-[#0A1329] flex items-center justify-center relative"
                            onClick={() => {
                                if (!user?.id || !user?.email) {
                                    handleShowModal();
                                } else {
                                    router("/shop-cart");
                                }
                            }}
                        >
                            {cart.length > 0 && (
                                <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs flex items-center justify-center rounded-full">
                                    {cart.length}
                                </span>
                            )}
                            <img src={CartIcon} alt="Cart" className="w-5 h-5" />
                        </button>
                    </div>
                </div>

                {/* <NavBarMenuLong /> */}
                <NavBarMenuLong language={language} />

                {/* Right: Icons and burger bar */}
                <div className="flex items-center space-x-2">
                    {/* Burger bar (mobile only) */}
                    {/* <div className="lg:hidden"> */}
                    <div className="lg:hidden ml-2 mr-2">
                        <button
                            className={`navbar-toggle ${isToggle ? "open" : ""}`}
                            id="isToggle"
                            onClick={() => toggleMenu()}
                        >
                            <div className="lines md:mb-[26px] mb-5">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>
                    </div>

                    {/* Icons */}
                    <ul className="hidden buy-button list-none mb-0 lg:flex items-center space-x-2">
                        <li className="dropdown inline-block relative ps-0.5" ref={cartRef}>
                            {cart.length > 0 && (
                                <p className="absolute top-0 left-0 translate-x-[-50%] translate-y-[-50%] rounded-full bg-red-500 p-1 w-6 h-6 flex items-center justify-center text-white">
                                    {cart.length}
                                </p>
                            )}
                            <button
                                className="dropdown-toggle size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full  text-white hover:bg-orange-400"
                                type="button"
                                onClick={() => {
                                    if (!user?.id || !user?.email) {
                                        handleShowModal();
                                    } else {
                                        router("/shop-cart");
                                    }
                                }}
                            >
                                <img src={CartIcon} alt="Cart" className="h-full w-full" />

                                {/* <span>
                                    <FiShoppingCart className="h-4 w-4" />
                                </span> */}
                            </button>
                        </li>
                        <li className="dropdown inline-block relative ps-0.5" ref={userRef}>
                            {user?.name || user?.email ? (
                                <>
                                    <button
                                        data-dropdown-toggle="dropdown"
                                        className="dropdown-toggle items-center"
                                        type="button"
                                        onClick={() => setUserManu(!userManu)}
                                    >
                                        <span className="size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full border border-orange-500 bg-orange-500 text-white">
                                            <div className="absolute inset-0 flex items-center justify-center bg-gray-300 rounded-full">
                                                <span className="font-bold text-white">
                                                    {user?.name.slice(0, 2).toUpperCase()}
                                                </span>
                                            </div>
                                        </span>
                                    </button>
                                    {userManu && (
                                        <div className="dropdown-menu absolute end-0 m-0 mt-4 z-10 w-48 rounded-md overflow-hidden bg-white dark:bg-slate-900 shadow dark:shadow-gray-700">
                                            <ul className="py-2 text-start">
                                                <li className="ms-0">
                                                    <p className="text-slate-400 pt-2 px-4">
                                                        {t.welcome} {user?.name}!
                                                    </p>
                                                </li>

                                                <li className="ms-0">
                                                    <div className="flex items-center font-medium py-2 px-4 dark:text-white/70  dark:hover:text-white">
                                                        <FiCreditCard className="h-4 w-4 me-2" />
                                                        {language === "ka" ? "კრედიტი " : "Credit "}
                                                        : {user.credit}
                                                    </div>
                                                </li>
                                                <li className="ms-0">
                                                    <Link
                                                        to="/user-setting"
                                                        className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white"
                                                    >
                                                        <FiUser className="h-4 w-4 me-2" />
                                                        {t.account}
                                                    </Link>
                                                </li>
                                                <li className="ms-0">
                                                    <Link
                                                        to="/contact"
                                                        className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white"
                                                    >
                                                        <FiHelpCircle className="h-4 w-4 me-2" />
                                                        {t.contact}
                                                    </Link>
                                                </li>
                                                <li className="border-t border-gray-100 dark:border-gray-800 my-2"></li>
                                                <li className="ms-0">
                                                    <button
                                                        onClick={() => {
                                                            logOutHandler();
                                                            router("/");
                                                        }}
                                                        className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white"
                                                    >
                                                        <FiLogOut className="h-4 w-4 me-2" />
                                                        {t.logout}
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="hidden lg:flex items-center gap-1">
                                    <button
                                        onClick={() => handleShowModal()}
                                        className="dropdown-toggle size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full  text-white hover:bg-orange-400"
                                    // className="py-1.5 px-2 md:px-3 text-sm rounded-lg bg-transparent border border-black flex items-center hover:bg-gray-100 dark:border-white dark:hover:bg-gray-800"
                                    >
                                        {/* <AiOutlineUser /> */}
                                        <img src={UserIcon} alt="UserIcon" className="w-full h-full" />

                                    </button>
                                </div>
                            )}
                        </li>
                        <div
                            className={`${user.name && "translate-y-[4px]"
                                } ml-2 hidden lg:inline-block`}
                        >
                            <Switcher />
                        </div>
                    </ul>
                </div>
            </div>

            {/* Navigation menu for mobile (toggled by burger bar) */}
            <div
                className={`${isToggle ? "block" : "hidden"
                    } absolute lg:hidden inset-x-0 top-[100%] pb-2 xl:pb-0 z-10 bg-white dark:bg-black dark:text-white`}
            >
                <ul className={`navigation-menu ${navlight === true ? "nav-light" : ""}`}>
                    <CategoriesMenu categoriesQuery={categoriesQuery} />

                    <li className={`${manu === "/shop?gender=2" ? "active" : ""}`}>
                        <a href="/shop?gender=2" className="sub-menu-item">
                            {language === "ka" ? "მამაკაცები" : "Men's"}
                        </a>
                    </li>
                    <li className={`${manu === "/womens" ? "active" : ""}`}>
                        <a href="/shop?gender=1" className="sub-menu-item">
                            {language === "ka" ? "ქალები" : "Women's"}
                        </a>
                    </li>
                    <li className={`${manu === "/kids" ? "active" : ""}`}>
                        <a href="/shop?gender=3" className="sub-menu-item">
                            {language === "ka" ? "ბავშვები" : "Kids"}
                        </a>
                    </li>
                    <li className={`${manu === "/shop?type=sales" ? "active" : ""}`}>
                        <a href="/shop?type=sales" className="sub-menu-item">
                            {language === "ka" ? "ფასდაკლება" : "Sale"}
                        </a>
                    </li>
                    <li className={`${manu === "/accessories" ? "active" : ""}`}>
                        <a href="/shop" className="sub-menu-item">
                            {language === "ka" ? "აქსესუარები" : "Accessories"}
                        </a>
                    </li>

                    {/* New Categories - Add proper IDs later */}
                    <li className={`${manu === "/shop?categories=12" ? "active" : ""}`}>
                        <a href="/shop?categories=12" className="sub-menu-item">
                            {language === "ka" ? "ქამარი" : "Belt"}
                        </a>
                    </li>
                    <li className={`${manu === "/shop?categories=13" ? "active" : ""}`}>
                        <a href="/shop?categories=13" className="sub-menu-item">
                            {language === "ka" ? "საფულე" : "Wallet"}
                        </a>
                    </li>
                    <li className={`${manu === "/shop?categories=16" ? "active" : ""}`}>
                        <a href="/shop?categories=16" className="sub-menu-item">
                            {language === "ka" ? "აბაზანის ფეხსაცმელი" : "Bath Slippers"}
                        </a>
                    </li>
                    <li className={`${manu === "/shop?categories=25" ? "active" : ""}`}>
                        <a href="/shop?categories=25" className="sub-menu-item">
                            {language === "ka" ? "ფეხსაცმელი" : "Shoes"}
                        </a>
                    </li>
                    <li className={`${manu === "/shop?categories=18" ? "active" : ""}`}>
                        <a href="/shop?categories=18" className="sub-menu-item">
                            {language === "ka" ? "მაისური" : "T-Shirt"}
                        </a>
                    </li>
                    <li className={`${manu === "/shop?categories=19" ? "active" : ""}`}>
                        <a href="/shop?categories=19" className="sub-menu-item">
                            {language === "ka" ? "შორტი" : "Shorts"}
                        </a>
                    </li>
                    <li className={`${manu === "/shop?categories=20" ? "active" : ""}`}>
                        <a href="/shop?categories=20" className="sub-menu-item">
                            {language === "ka" ? "საცურაო კოსტიუმი" : "Swimwear"}
                        </a>
                    </li>
                    <li className={`${manu === "/shop?categories=22" ? "active" : ""}`}>
                        <a href="/shop?categories=22" className="sub-menu-item">
                            {language === "ka" ? "კეპი" : "Cap"}
                        </a>
                    </li>


                </ul>
            </div>
            {/* <NavBarMenuLong /> */}
        </nav>
    );
}
